/*
 * Capitan formValidation v1.5.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.Capitan.de/
 *
 * Date: 2018-01-23
 * MIT License (MIT)
 */
var _ = {
  defaults: {
    componentSelector: '.form[data-validate="true"]:not(.js-init)',
    pluginOptions: {
      selectors: {},
      classes: {},
      callbacks: {},
      errorMessages: {}
    }
  }
};
var o = _.defaults;
/**
 * init parsley validation
 * @param component
 */

export function initPlugin(component) {
  window.Parsley.on('form:init', function (instance) {
    instance.element.classList.add('js-init');
  });
  $(component).parsley({
    trigger: 'focusout',
    errorClass: 'is-invalid',
    successClass: 'is-valid',
    excluded: '.u-hidden input, .u-hidden select, .u-hidden textarea',
    classHandler: function classHandler(el) {
      return el.$element.closest('.form__field-wrapper'); //working
    },
    errorsContainer: function errorsContainer(ParsleyField) {
      return ParsleyField.$element.attr('title');
    },
    errorsWrapper: false
  }).on('field:error', function (fieldInstance) {
    var currentInput = fieldInstance.$element;
    console.log('validation failed', fieldInstance); // append tooltip to select wrapper if select field is hidden

    if (currentInput.hasClass('select2-hidden-accessible')) {
      currentInput = currentInput.parent();
    }
  }).on('field:success', function (fieldInstance) {
    var currentInput = fieldInstance.$element; // remove tooltip from select wrapper on success

    if (currentInput.hasClass('select2-hidden-accessible')) {
      currentInput = currentInput.parent();
    }
  }).on('form:validate', function (instance) {
    // remove tooltip shown class to reset tooltip display
    instance.element.classList.remove('js-tooltip-after-submit'); // add js-validating class to indicate that form is validating

    instance.element.classList.add('js-validating');
  }).on('form:validated', function (instance) {
    // remove js-validating class when form is validated
    instance.element.classList.remove('js-validating');

    if (instance.validationResult) {
      instance.$element[0].dispatchEvent(new Event('is-validate-success'));
    } else {
      instance.$element[0].dispatchEvent(new Event('is-validate-error'));
    }
  }); //Textarea resize on write, copypaste etc.

  $('textarea').on('change drop keydown cut paste', function () {
    var $this = $(this);
    $this.height('auto');
    $this.height($this.prop('scrollHeight'));
  }); // fix transition label overlay value
  // if value is set, keep focused label position on top by add/remove focused class

  $('input, textarea', component).on('change', function () {
    var $this = $(this);

    if ($this.val() !== '') {
      $this.focus();
      $this.addClass('focused');
      $this.blur();
    } else {
      $this.removeClass('focused');
    }
  }); //textare check for empty inputfield and apply style according to result

  $('.form, textarea, input').blur(function () {
    console.log('GOT TEXTAREA');

    if ($(this).val().trim() != '') {
      $(this).parent().addClass('is-active');
    } else {
      $(this).parent().removeClass('is-active');
    }
  }); // Password Validation (Weak/Moderate/Strong)
  // 4 Acceptance Criteria (8+ Chars, Numbers, Letters, Special Chars)

  $('input[data-password-validation]', component).on('keyup', function () {
    var $this = $(this);
    var aks = 0;
    if ($this.val().length >= 8) aks++; // 8+ characters

    if (/\d/.test($this.val())) aks++; // numbers

    if (/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test($this.val())) aks++; // special characters

    if (/[a-z \-_.äöüß]/.test($this.val())) aks++; // lowercase character

    if (/[A-Z \-_.ÄÖÜ]/.test($this.val())) aks++; // uppercase character

    if ($this.val().length === 0) aks = 0;
    $this.parent().removeClass('input--state-strength-0');
    $this.parent().removeClass('input--state-strength-1');
    $this.parent().removeClass('input--state-strength-2');
    $this.parent().removeClass('input--state-strength-3');
    $this.parent().removeClass('input--state-strength-4');
    $this.parent().children('.js-alertbox').removeClass('u-hidden');
    $this.parent().addClass("input--state-strength-".concat(aks));

    if (aks == 4) {
      $this.parent().children('.js-alertbox').addClass('u-hidden');
    }
  }); // Validate Password Repetition

  $('input[data-password-confirmation]', component).on('keyup', function () {
    var $this = $(this);

    if ($this.parent().prev().children('input')[0].value === $this.val()) {
      $this.parent().addClass('is-valid');
      $this.parent().removeClass('set-invalid');
      $this.parent().removeClass('is-invalid');
    } else {
      $this.parent().addClass('set-invalid');
      $this.parent().removeClass('is-valid');
      $this.parent().addClass('is-invalid');
    }
  }); // used for custom selects with select2 implementation
  // select2 triggers select change events -> after that validate with parsley

  $('select', component).on('change', function () {
    var $this = $(this);
    $this.parsley().validate();
  });

  if ($(component).hasClass('form--multistep')) {
    import(
    /* webpackChunkName: "form-multistep" */
    './form-multistep').then(function (module) {
      module.init(component);
    });
  }
}
export function init() {
  if (document.querySelector(o.componentSelector)) {
    import(
    /* webpackChunkName: "form-validation" */
    'parsleyjs').then(function () {
      import(
      /* webpackChunkName: "form-validation" */
      'parsleyjs/dist/i18n/de').then(function () {
        import(
        /* webpackChunkName: "form-validation" */
        'parsleyjs/dist/i18n/de.extra').then(function () {
          var components = $(o.componentSelector);

          for (var i = 0; i < components.length; i += 1) {
            initPlugin(components[i]);
          }
        });
      });
    });
  }
}